export const ARCHIVE_INTAKE_FORM_SUBMISSION_MUTATION = `
  mutation ArchiveIntakeFormSubmission($clientId: ID!, $intakeFormId: ID!) {
    archiveIntakeFormSubmission(clientId: $clientId, intakeFormId: $intakeFormId) {
      result
      errors
    }
  }
`
